export const ENTITY_SUGGESTIONS_MIN_WIDTH = 320;

export const ENTITY_SUGGESTIONS_MAX_WIDTH = 420;

export const ENTITY_SUGGESTIONS_MAX_HEIGHT = 320;

export const ENTITY_SUGGESTIONS_ICON_SIZE = 16;

export const ENTITY_SUGGESTIONS_TITLE = 'Reference a loan item';

export const ENTITY_SUGGESTIONS_EMPTY_LABEL = 'No matching items';

export const ENTITY_SUGGESTIONS_LOADING_LABEL = 'Loading loan items…';

export const ENTITY_SUGGESTIONS_LOADING_SPINNER_SIZE = 16;

export const ENTITY_SUGGESTIONS_KEYBOARD_HINTS = [
  { id: 'navigate', key: '↑↓', label: 'Navigate' },
  { id: 'select', key: '↵', label: 'Select' },
  { id: 'dismiss', key: 'Esc', label: 'Dismiss' },
];
